import { isAfter, isBefore, isValid, parse, startOfDay } from 'date-fns'

import { EInvoicingAddressingLine } from '@features/eInvoicing/types/eInvoicingAddressingLine'

const ADDRESSING_LINE_DATE_FORMAT = 'yyyyMMdd'

const parseAddressingLineDate = (date: string | null): Date | undefined => {
  if (!date) {
    return undefined
  }

  const parsedDate = parse(date, ADDRESSING_LINE_DATE_FORMAT, new Date())

  return isValid(parsedDate) ? parsedDate : undefined
}

export const isActiveAddressingLine = ({ endDate, startDate }: EInvoicingAddressingLine): boolean => {
  const today = startOfDay(new Date())
  const start = parseAddressingLineDate(startDate)
  const end = parseAddressingLineDate(endDate)

  if (start && isAfter(start, today)) {
    return false
  }

  if (end && isBefore(end, today)) {
    return false
  }

  return true
}
